import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Tournament } from '@/types/cricket';
import { Button } from '@/components/ui/button';

interface TournamentSelectorProps {
  tournaments: Tournament[];
  selectedTournamentId?: string;
  onTournamentChange: (tournamentId: string) => void;
  onClearSelection?: () => void;
  labelText?: string;
}

const TournamentSelector: React.FC<TournamentSelectorProps> = ({
  tournaments,
  selectedTournamentId,
  onTournamentChange,
  onClearSelection,
  labelText
}) => {
  return (
    <div className="flex items-center gap-4">
      <label className="text-sm font-medium">{labelText || "Select Tournament:"}</label>
      <Select value={selectedTournamentId} onValueChange={onTournamentChange}>
        <SelectTrigger className="w-64">
          <SelectValue placeholder={labelText ? `Choose a ${labelText.toLowerCase().replace(':', '...')}` : "Choose a tournament..."} />
        </SelectTrigger>
        <SelectContent>
          {tournaments.map(tournament => (
            <SelectItem key={tournament.id} value={tournament.id}>
              {tournament.name} - {tournament.location}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {onClearSelection && (
        <Button variant="outline" onClick={onClearSelection}>
          Clear
        </Button>
      )}
    </div>
  );
};

export default TournamentSelector;
